export function csrfToken() {
  let token = document.querySelector("meta[name=csrf-token]");
  if (token) {
    return token.getAttribute("content");
  }
}
